// extracted by mini-css-extract-plugin
export default {"remark":"RemarkMessage_remark__qgprY","translationMissing":"RemarkMessage_translationMissing__-bYWg"};